import { render, staticRenderFns } from "./Bsa.vue?vue&type=template&id=50e339a2&"
import script from "./Bsa.vue?vue&type=script&lang=js&"
export * from "./Bsa.vue?vue&type=script&lang=js&"
import style0 from "./Bsa.vue?vue&type=style&index=0&id=50e339a2&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports